module.exports = __webpack_public_path__ + "img/zhaopin_icon.0eb740d9.png";